module.exports = __webpack_public_path__ + "img/face4.54ec7db3.png";